export default __webpack_public_path__ + "static/media/17.c6dba96a.jpg";